import { useState, useEffect, useRef } from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { Star, Clock, Users, Award } from "lucide-react";

const CountUp = ({ end, suffix = "", duration = 2000, isVisible }) => {
  const [count, setCount] = useState(0);
  const hasAnimated = useRef(false);

  useEffect(() => {
    if (!isVisible || hasAnimated.current) return;
    hasAnimated.current = true;

    let start = 0;
    const increment = end / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [isVisible, end, duration]);

  return (
    <span>
      {count}
      {suffix}
    </span>
  );
};

const stats = [
  {
    value: 7,
    suffix: "+",
    label: "Années d'expérience",
    icon: Award,
  },
  {
    value: 75,
    suffix: "+",
    label: "Avis Google",
    icon: Star,
  },
  {
    value: 4.9,
    suffix: "/5",
    label: "Note Google",
    icon: Star,
    isDecimal: true,
  },
  {
    value: 7,
    suffix: "",
    label: "Places passagers",
    icon: Users,
  },
];

export const StatsSection = () => {
  const [ref, isVisible] = useScrollAnimation(0.3);

  return (
    <section ref={ref} className="py-[60px] md:py-[80px] bg-[#1a1d2e] border-t border-b border-[#c9a84c]/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat, idx) => (
            <div
              key={idx}
              className={`text-center transition-all duration-700 ${
                isVisible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-6"
              }`}
              style={{ transitionDelay: `${idx * 150}ms` }}
            >
              <div className="flex justify-center mb-3">
                <stat.icon size={20} strokeWidth={1.5} className="text-[#c9a84c]/60" />
              </div>
              <div
                className="text-[36px] md:text-[44px] font-normal text-white mb-1"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                {stat.isDecimal ? (
                  <span>{isVisible ? "4,9" : "0"}{stat.suffix}</span>
                ) : (
                  <CountUp end={stat.value} suffix={stat.suffix} isVisible={isVisible} />
                )}
              </div>
              <p
                className="text-[13px] text-white/40 tracking-[0.05em] uppercase"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
